<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="sa_custname,sa_code,pr_detail"
      placeholder="输入客户、单号、物料进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.sa_code+item.sd_detno"
        :to="{name: 'SaleExecuteDetail', params: { item }}"
      >
        <div class="weui-cell__bd">
          <p>{{ item.sa_custname }}</p>
          <p class="list-item-muted">{{item.sa_code}} #{{item.sd_detno}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{ item.sd_prodcode }} {{item.pr_detail}}</p>
          <p class="list-item-muted">{{ item.sd_qty }} {{ item.pr_unit }}</p>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">共：{{items.length}}条</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/sale/report/saleExecute",
      filters: [
        {
          type: "date",
          name: "sa_date"
        }
      ],
      params: {
        mode: "DETAIL"
      }
    };
  }
};
</script>